import CharacterClass from './CharacterClass'

export const tierTokenTypes: { [key: string]: CharacterClass[] } = {
  Dreadful: ['Death Knight', 'Demon Hunter', 'Warlock'],
  Mystic: ['Druid', 'Hunter', 'Mage'],
  Venerated: ['Paladin', 'Priest', 'Shaman'],
  Zenith: ['Evoker', 'Monk', 'Rogue', 'Warrior'],
}
